import { useMemo } from 'react';

export function useSplitQuotesByStatus(quotes) {
  const activeQuotes = useMemo(
    () => {
      if (!quotes) return [];

      const active = quotes?.filter(
        (quote) => quote.status?.toLowerCase() === 'active'
      );
      return active;
    },
    [quotes]
  );

  const expiredQuotes = useMemo(
    () => {
      if (!quotes) return [];

      const expired = quotes?.filter(
        (quote) => quote.status?.toLowerCase() === 'expired'
      );
      return expired;
    },
    [quotes]
  );

  return { activeQuotes, expiredQuotes };
}